import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const Terms_and_ConditionReadSlice = createSlice({
  name: "Terms_and_ConditionReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    Terms_and_ConditionRead: (state) => {
      state.isLoading = true;
    },
    successTerms_and_ConditionRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureTerms_and_ConditionRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearTerms_and_ConditionRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  Terms_and_ConditionRead,
  failureTerms_and_ConditionRead,
  successTerms_and_ConditionRead,
  clearTerms_and_ConditionRead,
} = Terms_and_ConditionReadSlice.actions;

export default Terms_and_ConditionReadSlice.reducer;
